export const enLang = {
  translation: {
    data: 'Data',
    date: 'Date',
    view_all: 'View all',
    add: 'Add',
    list: 'List',
    edit: 'Edit',
    update: 'Update',
    share: 'Share',
    details: 'Details',
    tags: 'Tags',
    name: 'Name',
    groups: 'Groups',
    start_date: 'From',
    end_date: 'To',
    search: 'Search',
    workspace: 'Workspace',
    last_measure: 'Last measure',
    state: 'State',
    any_state: 'Any state',
    state_active: 'Active',
    state_inactive: 'Inactive',
    state_to_be_deleted: 'To be deleted',
    type: 'Type',
    reports: 'Reports',
    dashboard: 'Dashboard',
    home: 'Home',
    trackgas: 'TrackGas',
    notifications: 'Notifications',
    device_changes: 'Device changes',
    notifications_view_all: 'View all notifications',
    notifications_pending_read: 'You have {{notifications_count}} unread notifications',
    mgb_alarm_desc: '{{metric}} level goes below {{level}}',
    mga_alarm_desc: '{{metric}} level goes above {{level}}',
    mgbt_alarm_desc: '{{metric}} level is between {{bottom_level}} and {{top_level}}',
    device_add: 'Add a device',
    device_shared_successfuly: 'Device shared successfully',
    devices: 'Devices',
    device_details_breadcrumb: '{{device_name}} details',
    identifier: 'Identifier',
    devices_export: 'Export devices',
    device_groups: 'Device groups',
    device_groups_placeholder: 'Select from list',
    device_location: 'Device location',
    device_properties: 'Device properties',
    device_alarm_state: 'Device is in alarm state',
    device_back_to_normal_state: 'Device is back to normal',
    select_device_type: 'Select device type',
    calculated_data: 'Calculated data',
    assets: 'Assets',
    configuration: 'Configuration',
    alarms: 'Alerts',
    add_alarm: 'Add alarm',
    alarm_created: 'Alarm created',
    alarm_updated: 'Alarm updated',
    alarm_select_time_window: 'Select time window type',
    alarm_select_time_window_time_window: 'Time window',
    alarm_select_time_window_measure_count: 'Measure count',
    alarm_select_time_window_measure_count_explanation:
      'Specified measure count will be used to calculate average value and check the configured trigger',
    alarm_select_time_window_time_window_explanation:
      'All measures received within specified interval will be considered',
    alarm_select_time_window_time_window_select_units: 'Select units',
    hours: 'Hours',
    days: 'Days',
    alarm_select_trigger: 'Select trigger type',
    alarm_new_data_trigger: 'Trigger on each new data',
    alarm_scheduled_trigger: 'Scheduled trigger',
    edit_alarm: 'Edit alarm',
    alarm_time_window_header: 'Time window',
    alarm_time_window_content:
      'The time window defines alarm time conditions. There are two kinds of time windows. Measure count based and time unit based (minutes, hours, days...)',
    alarm_trigger_header: 'Trigger',
    alarm_trigger_content:
      'Trigger configuration defines when the alert needs to be activated or deactivated. There are two kinds of triggers. <bold>Measure level</bold>, that is triggered when the selected measure level meets some criteria (being above or below a user-set level, or being between two user-defined levels). <bold>Lack of measure trigger</bold>. This one triggers when there are no measures in the time specified in the "time window" section. In this case, a time-based time window must be used.',
    alarm_action_notify_alarm_state: 'Notify when change to alarm state',
    alarm_action_notify_back_to_normal_state: 'Notify when changes to back to normal',
    actions_header: 'Actions',
    actions_content:
      'Actions list that will be performed when an alarm changes its state to Alarm or Back to normal. Each action can be configured separately to be triggered when it goes to Alarm state, back to normal state, or in both cases',
    shared: 'Shared',
    select_language: 'Select language',
    en: 'English',
    es: 'Spanish',
    autodetect: 'Detect',
    error_unable_to_logout: 'Unable to logout',
    alarm_state_change_list: 'Alarm state change list',
    alarm_state_change_desc: '{{alarm_name}} changes to {{alarm_state}}',
    received_data: 'Received data',
    measure_updated: 'Measure data updated',
    measure_updated_error: 'Error while updating measure data',
    update_measure_text: 'Original values will be overwritten',
    device_delete_cta: 'Delete this device',
    device_delete_confirm: 'Do you confirm that you wish to delete this device?',
    device_delete_confirm_dialog: "This action can't be undone",
    confirm: 'Confirm',
    cancel: 'Cancel',
    'receive.weekly_reports': 'Receive weekly status report',
    'receive.monthly_reports': 'Receive monthly status report',
    liters_available: 'Available volume',
    consum_charts: 'Consumption charts',
    measure_chart: 'Measurement charts',
    deposit_details: 'Deposit details',
    data_included: 'Information included',
    charts: 'Charts',
    format: 'Format',
    share_report: 'Share reports',
    send: 'Send',
    download: 'Download',
    trimester: 'Trimester',
    to_now: 'Until now',
    trimestral: 'Quarterly',
    annual: 'Annual',
    temporal_interval: 'Time interval',
    add_deposit: 'Add deposit',
    deposits: 'Deposits',
    deposits_selected: 'selected deposits',
    auto_reports: 'Automatic reports',
    request_delivery: 'Request Supply',
    last_temperature: 'Last temperature',
    capacity: 'Capacity',
    raw_value: 'RAW value',
    unknown: 'Unknown',
    fill: 'Fill',
    last_fill: 'Last fill',
    provider: 'Provider',
    measurement: 'Measurement',
    last_measurement: 'Last measurement',
    recurrence: 'Recurrence',
    maintenance: 'Maintenance',
    last_revision: 'Last revision',
    next_revision: 'Next revision',
    contact: 'Contact',
    do_you_have_doubts: 'Do you have any questions?',
    contact_with_distributor: 'Contact the dealer',
    contact_name: 'Contact name',
    consum_chart: 'Consumption graph',
    weekly: 'Weekly',
    monthly: 'Monthly',
    receive_alert_when: 'Receive alert when the capacity of the deposit is',
    less_than_15: 'less than 15%',
    deposit_capacity: 'Tank capacity',
    daily_average_consum: 'Average daily consumption',
    weekly_average_consum: 'Average weekly consumption',
    remaining_days: 'Remaining days',
    new_request: 'New order',
    deposit_empty_in: 'Empty tank in',
    request_gasoil: 'Ask for Diesel',
    you_can_downloa_report:
      'You can download the status report at any time by selecting a date and pressing the button',
    deposit: 'Deposit',
    place: 'Place',
    recurrence_measurement: 'Recurrence measurement',
    fill_state: 'Filled state',
    fill_prevision: 'Filling forecast',
    new_delivery: 'New supply',
    TOTAL: 'TOTAL',
    la_solicitud_del_suministro:
      'The Supply request will be available soon. Sorry for the inconvenience.',
    received_date: 'Reception date',
    delivery_configurations: 'Shipping Settings',
    delivery_configuration: 'Shipping Setting',
    add_delivery_configuration: 'AAdd a shipping configuration',
    delivery_configuration_created: 'Shipping Configuration Created',
    create_delivery_configuration: 'Create shipping configuration',
    bulk: 'Bulk',
    fixed: 'Fixed',
    unit: 'Unit',
    slots: 'Cells',
    slot_amount: 'Quantity per cell',
    min_slots: 'Minimum cells',
    max_slots: 'Maximum cells',
    min: 'Minimum',
    max: 'Maximum',
    device_type: 'Type of device',
    name_is_required: 'Name is required',
    welcome_again: 'Hello, welcome back to',
    access_to_giraf: 'Access to Giraf.io',
    enter_credentials: 'Enter your credentials below',
    tag_device_created: 'Device tag created',
    tag_device_updated: 'Updated device label',
    add_tag: 'Add a tag',
    changes_alarm_state: 'Alarm status changes',
    download_reports: 'Download reports',
    deposit_state: 'Deposit State',
    gasoil_type: 'Gasoil Type',
    change_in_alarm_state: 'Change in alarm status',
    created: 'Created',
    alert_state: 'Alert Status',
    device_identifier: 'Device identifier',
    device_name: 'Device Name',
    last_data_received: 'Last data received',
    last_data: 'Last data date',
    alarm_data: 'Alarm information',
    without_alarm_asociated: 'no associated alarm',
    delivery_configuration_updated: 'Updated shipping settings',
    aprox_weight: 'Weight approx.',
    daily_consum: 'Daily consumption',
    weekly_consum: 'Weekly consumption',
    edit_delivery_configuration: 'Edit shipping settings',
    solicitud_de_suministro: 'Supply request sent successfully',
    emails_list: 'Email list',
    add_email: 'Add email',
    feed_type: 'Type of feed',
    breeding_number: 'Breeding number',
    select_feed_type: 'Select the type of feed',
    save: 'Save',
    delivery_requests: 'Supply requests',
    user: 'User',
    status: 'Status',
    silos: 'Silos',
    total_load: 'Full load',
    delivery_date: 'Shipping date',
    see_detail: 'See detail',
    detail: 'Detail',
    product_types: 'Feed types',
    options: 'Options',
    add_product_type: 'Add Type of feed',
    product_type_created: 'Type of feed created',
    create_product_type: 'Create feed type',
    product_type: 'Product type',
    confirm_delete_product_type: 'Are you sure you want to delete the type of feed?',
    product_type_deleted: 'Type of feed removed',
    delete_product_type: 'Delete Type of feed',
    product_schedule: 'Breeding',
    product_schedule_template_created: 'Template created',
    product_schedule_created: 'Breeding created',
    product_schedule_template_edited: 'Tempalte edited',
    create_product_template_schedule: 'Create template',
    product_schedule_edited: 'Breeding edited',
    create_product_schedule: 'Create breeding',
    edit_product_schedule: 'Edit breeding',
    by_unit: 'By unit',
    schedule_type: 'Programming type',
    quantity: 'Quantity',
    select_product_type: 'Select the type of feed',
    ordinal: 'Order',
    type_is_required: 'Type is required',
    requited_one_product_type: 'It is necessary to introduce at least one type of feed',
    product_schedule_templates: 'Breeding Schedule Templates',
    add_product_schedule_template: 'Add breeding template',
    confirm_delete_product_schedule_template:
      'Are you sure you want to delete this breeding schedule template?',
    confirm_delete_product_schedule: 'Are you sure you want to delete this breeding?',
    delete_product_schedule_template: 'Delete Breeding Template',
    delete_product_schedule: 'Delete Breeding',
    product_schedule_template_deleted: 'Breeding Schedule Template Removed',
    n_items: '# items',
    schedules: 'Breedings',
    schedule_templates: 'Breeding tempalates',
    add_product_schedule: 'Add breeding',
    template: 'Template',
    units: 'Units',
    reference: 'Reference',
    units_is_required: 'Units is required',
    template_is_required: 'Template is required',
    devices_is_required: 'Set at least one device',
    reference_is_required: 'Reference is required',
    devices_at_least_1: 'Set at least one device',
    consumed: 'Consumed',
    product_schedules: 'Breedings',
    n_devices: '# devices',
    n_kilos_consumed: '# kg consumed',
    required: 'Required',
    active: 'Active',
    inactive: 'Inactive',
    phases: 'Phases of ',
    breeding: 'breeding',
    Breeding: 'Breeding',
    breeding_details: 'Breeding details',
    breeding_devices: 'Breeding devices',
    device_details: 'Device details',
    products_list: 'List of products',
    order_summary: 'Order summary',
    device_not_asigned_breeding: 'This device is not assigned to any breeding',
    add_building: 'Add building',
    assign_building: 'Assing building',
    create_building: 'Create building',
    building_created: 'Building created',
    building_updated: 'Building updated',
    edit_building: 'Edit building',
    device_assigned_to_building: 'Device assigned to a building',
    add_device_to_this_building: 'Add a device to this building',
    building_assigned_to_devicetag: 'Building assigned to farm correctly',
    building_unlink_success: 'Building successfully unlinked',
    unlink_building: 'Unlink building',
    assign_building_to: 'Assign building to ',
    device_unlinked_to_building: 'Device unlinked from building',
    confirm_unlink_device: 'Are you sure you want to unlink this device from this building?',
    building: 'Building',
    device_group: 'Device group',
    device_group_created: 'Device group created',
    device_group_updated: 'Device group updated',
    assign_device: 'Assign device',
    device: 'Device',
    assign_device_to: 'Assign device to',
    create_device: 'Create device',
    device_added: 'Device created correctly',
    download_failed: 'Download failed',
    never: 'Never',
    available: 'Available',
    device_information: 'Deposit information',
    free_space: 'Free volume',
    available_charge: 'Approximate volume',
    deposit_type: 'Deposit type',
    sector: 'Sector',
    welcome_to: 'Welcome to',
    link_incorrect_or_timed_out: 'This link is incorrect, or has expired',
    to_access_panel_set_password: 'To access the panel, set a password',
    set_password: 'Set password',
    return: 'Return',
    confirm_order: 'Order confirmation',
    insert_comment: 'Enter a comment',
    comment: 'Comment',
    confirm_the_reception_of_delivery_request: 'Confirm receipt of supply request',
    confirm_reception: 'Confirm reception',
    go_to_login: 'Go to login',
    unlink: 'Unlink',
    confirm_unlink_building: 'Are you sure you want to unlink this device?',
    unlink_device: 'Unlink device',
    product_list: 'Products list',
    delivery_request_received_confirmed: 'Confirmation of receipt of Supply Request',
    of: 'of',
    confirmed: 'Confirmed',
    delivered: 'Sent',
    general_data: 'General data',
    add_devices: 'Add devices',
    select_devices: 'Select devices',
    percent: 'Percent',
    remain: 'Remain',
    temperature: 'Temperature',
    battery_level: 'Battery Level',
    consumption_graphs: 'Consumption charts',
    measurement_charts: 'Measurement charts',
    report_sended_correctly: 'Report sent successfully',
    each_8_hours: 'Every 8 hours',
    each_4_hours: 'Every 4 hours',
    each_12_hours: 'Every 12 hours',
    silos_and_gasoil_deposit: 'Silos and gas deposits',
    counters: 'Counters',
    to_change_date_use_selector: 'If you want to change the date you can use the selector.',
    under_construction: 'In construction',
    we_are_working: 'We are working to have this page available as soon as possible.',
    sensor_calibration_text:
      'The sensors must be calibrated in order to display the information correctly. When this sensor has been calibrated, check the box.',
    pending_calibration: 'Pending calibration',
    invite: 'Invite',
    no_breeding: 'No breeding',
    pending_deliveries: 'Pending deliveries',
    pending_delivery_requests: 'This device has pending provisioning requests.',
    created_date: 'Created date',
    delivery_request: 'Delivery Request',
    items: 'Items',
    total: 'Total',
    delivery_request_deleted: 'Delivery request deleted',
    delivery_request_confirm: 'Confirm delete',
    delivery_request_delete_confirm_dialog:
      '¿Are you sure you want to delete this delivery request?',
    message: 'Message',
    volumen_aproximado: 'Approximate volume',
    do_not_you_remember_your_password: 'Do not you remember your password?',
    please_fill_your_email:
      'Please enter the email associated with your account and we will send you a confirmation code to reset your password.',
    request_sent_correctly: 'Request sent successfully',
    we_have_sent_an_email_to: 'We have sent a code to',
    please_check_you_maibox:
      'Please check your email, and copy and paste the code below to reset your password',
    reset_password: 'Reset password',
    email_incorrect: 'Wrong email',
    email_required: 'Email required',
    email_address: 'Email address',
    restart_password: 'Restart pasword',
    input_error: 'the deposit type, identifier, name, state and address fields must be filled out',
    device_shared: 'Device shared',
    device_shared_delete: 'Confirm shared device deletion',
    device_shared_delete_dialog: 'Are you sure you want to delete this shared device?',
    device_shared_deleted: 'Shared device removed',
    shared_with: 'Shared with',
    device_tag_shared: 'Device group shared',
    device_and_tags_shared: 'Devices and tag devices shared',
    device_tags_shared: 'Device tags shared',
    error_getting_devices: 'Error getting devices',
    tag_shared_delete_dialog: 'Are you sure you want to delete shared device tag?',
    tag_shared_delete: 'Delete shared device tag',
    province: 'Province',
    password_set_correctly: 'Password assigned correctly',
    register_in_giraf: 'Register in Giraf',
    minimum_3_chars: 'Minimum 3 chars',
    maximum_255_chars: 'Maximum 255 chars',
    maximum_150_chars: 'Máximo 150 chars',
    valid_email: 'The email address must be correct',
    register_success: 'Correct register',
    register: 'Register',
    url: 'URL',
    email: 'Email',
    creating_workspace: 'Creating workspace',
    creating_user: 'Creating user',
    register_success_reset_password_sent:
      'We have successfully registered the workspace. Please, establish your password from the link that we have sent you to the email',
    password: 'Password',
    password_rules:
      'Password must have at least one capital letter, one number, and one special character',
    email_is_required: 'Email is required',
    'name.not_empty_string': 'Name required',
    'identifier.not_empty_string': 'Identifier required',
    'location.not_empty_string': 'Location required',
    'deviceTypePreset.not_empty_string': 'Device Type (deviceTypePreset) required',
    'deviceType.not_empty_string': 'Device Type (deviceType) required',
    'state.not_empty_string': 'Status required',
    parameters: 'Parameters',
    'parameters.not_empty_string': 'Parameters required',
    volume: 'Volume',
    level: 'Level',
    picture: 'Picture',
    value: 'Value',
    battery: 'Battery',
    ocr_counter_state: 'OCR Counter State',
    update_profile: 'Update profile',
    mfa_status: 'Multi Factor Authentication',
    update_profile_text: 'Update your profile information',
    update_profile_success: 'Profile updated successfully',
    update_profile_load: 'Updating profile',
    deposit_l: 'Deposit (L)',
    calibration_text_1: 'To calibrate the device, click on a point on the graph',
    click_on: 'Press a',
    second_point: 'second point',
    to_complete_calibration: 'to complete the calibration',
    device_calibration: 'Device calibration',
    device_calibration_text_1:
      'Below you can see the two calibration points. Below each point is the date of the measurement and all data available for this point.',
    device_calibration_text_2:
      'To calibrate, assign a value in Kg in "Value Point 1", and in "Value Point 2".',
    device_calibration_text_3:
      'Measurements cannot yet be saved. We will soon complete the development of this section.',
    point_value_1: 'Value Point 1',
    point_value_2: 'Value Point 2',
    calibration_sended: 'Calibration sended',
    almost_one_point_different_0: 'Almost one point must be different to 0',
    send_calibration: 'Send calibration',
    kilos: 'Kilos',
    download_pdf: 'Download PDF',
    device_deport_of: 'Device report of',
    chart_measurements: 'Chart measurements',
    from: 'from',
    to: 'to',
    define_sector: 'You have to set a sector',
    define_client_number: 'You have to set client number',
    naves: 'Buildings',
    select_a_value: 'Select a value',
    error_downloading_try_parts: "There was an error downloading the report. Let's try it in parts",
    code: 'Code',
    repeat_password: 'Repeat password',
    code_required: 'Code required',
    password_required: 'Password required',
    passwords_must_match: 'Passwords must match',
    password_changed_successfully: 'Password changed successfully',
    login: 'Login',
    remember_me: 'Remember me',
    new_password: 'New password',
    confirm_new_password: 'Confirm new password',
    login_success: 'Login successful',
    email_must_have_correct_email: 'The email field must contain a correct email address.',
    email_valid_address: 'Email must be a valid email address',
    new_password_required: 'New password is required',
    confirm_new_password_is_required: 'Confirm new password is required',
    password_dont_match: "Passwords don't match",
    cumulative_flow: 'Cumulative flow',
    maximum_capacity: 'Maximum capacity',
    actual_weight: 'Actual weight',
    free_weight: 'Free weight',
    consumed_kilos: 'Kilos consumed',
    Available: 'Available',
    deleted: 'Deleted',
    delete: 'Delete',
    downloading_try_parts:
      "The report is too long. Let's download it in parts. You can select a specific group of devices to avoid downloading all at once.",
    no_limit: 'No limit',
    select_no_limit: 'Choose if you want not to limit amount',
    No: 'No',
    Yes: 'Yes',
    recurring_supply: 'Recurring supply',
    report_downloaded: 'Report downloaded',
    'Download finished': 'Download finished',
    number_by_report: '# devices by report'
  }
};
